import React, { useEffect } from 'react';
import ModalShell from './ModalShell';
import { haptic } from '../utils/vibration';

const AddressWithoutStreetConfirmModal = ({ suggestion, onCancel, onConfirm }) => {
  useEffect(() => {
    if (suggestion) {
      haptic('warning');
    }
  }, [suggestion]);

  const handleCancel = () => {
    haptic('close');
    onCancel?.();
  };

  const handleConfirm = () => {
    haptic('selection');
    onConfirm?.();
  };

  const address = suggestion?.value || suggestion?.unrestricted_value || '';

  return (
    <ModalShell
      open={Boolean(suggestion)}
      onClose={handleCancel}
      variant="sheet"
      zIndexClass="z-[100]"
      panelClassName="w-full max-w-md rounded-2xl bg-white p-5 shadow-xl dark:bg-gray-900"
    >
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100">В адресе нет улицы</h3>
        <p className="mt-2 text-sm leading-5 text-gray-600 dark:text-gray-300">
          <span className="font-medium text-gray-900 dark:text-gray-100">{address}</span>
          <br />
          DaData не указала улицу. Продолжить с этим адресом?
        </p>
        <div className="mt-5 flex gap-2">
          <button
            type="button"
            onClick={handleCancel}
            className="min-h-10 flex-1 rounded-xl bg-gray-100 px-3 text-sm font-semibold text-gray-800 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-100"
          >
            Изменить адрес
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            className="min-h-10 flex-1 rounded-xl bg-blue-600 px-3 text-sm font-semibold text-white hover:bg-blue-700"
          >
            Продолжить
          </button>
        </div>
      </div>
    </ModalShell>
  );
};

export default AddressWithoutStreetConfirmModal;
